import React, { useState, createContext } from 'react';
// import api from '../services/api';

const AuthContext = createContext({});

const ConfigProvider = ({ children, userData }) => {
  const [usuario, setUsuario] = useState(userData);
  const [listaLembretes, setListaLembretes] = useState([]);

  const atualizarUsuario = (usuarioAtualizar) => {
    setUsuario(usuarioAtualizar);
  };

  const atualizarLembretes = (lista) => {
    setListaLembretes(lista);
  };

  return (
    <AuthContext.Provider
      value={{ usuario, atualizarUsuario, listaLembretes, atualizarLembretes }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { ConfigProvider };

export default AuthContext;
